import React, { Fragment, useEffect, useState } from 'react';
import InsuranceRequest from './InsuranceRequest';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../sessionStorage';
import PropTypes from 'prop-types';
import { Disclaimer, PrudentialHandoffMessage, PrudentialPlanFeatures } from './Constant';
import { GeneratePrudentialHandoffRequest } from './PrudentialRequestObjects';

export default function Prudential(props) {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showResumeCaseModal, setShowResumeCaseModal] = useState(false);
  const [apiResponseData, setApiResponseData] = useState(null);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const onPrudentialSubmit = (submitRequest) => {
    const { email, firstName, lastName, setLoadingFromComponent } = submitRequest;
    setLoading(true);
    setLoadingFromComponent(true);
    const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;
    const account = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

    fetch(`${covrServicesUrl}/api/PrudentialSimplyTerm/PrudentialSILTHandoffSubmit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'SessionId': account.sessionId
      },
      body: JSON.stringify(GeneratePrudentialHandoffRequest(props.basicInfo, props.formData, submitRequest)),
    })
      .then(res => res.json())
      .then(json => {
        if ((json.isMatchFound && json.data?.handOffURL) || json.data?.recordStatus === 0) {
          setApiResponseData(json.data);
          setShowResumeCaseModal(true);
          setLoading(false);
          setLoadingFromComponent(false);
          return;
        }
        if (json.isSuccess && json.data?.applicationId) {
          const quoteId = json.data.quotationId;
          const applicationId = json.data.applicationId;
          const PRUDENTIAL_TYPE_ID = "";
          props.logQuote(email, firstName, lastName, props.formData.quoter, PRUDENTIAL_TYPE_ID, quoteId, applicationId).then(() => {
            setLoading(false);
            setLoadingFromComponent(false);
            window.location.replace(json.data.handOffURL);
          });
        }
        else {
          setErrorMessage(json.data?.errorMessage || "Failed to submit your internal application.");
          setLoading(false);
          setLoadingFromComponent(false);
          window.scroll(0, 0);
        }
      })
      .catch((error) => {
        setErrorMessage(error)
        setLoading(false);
        setLoadingFromComponent(false);
        window.scroll(0, 0);
      });
  };

  return <Fragment>
    <InsuranceRequest
      quoterFormState={props.formData.quoter}
      disclaimer={Disclaimer}
      planFeature={PrudentialPlanFeatures}
      onBack={props.onBack}
      onSubmit={onPrudentialSubmit}
      handoffMessage={PrudentialHandoffMessage}
      errorMessage={errorMessage}
      enablePhone={true}
      showUsResident={true}
      showExistingInsurance={true}
      isLoading={loading}
      showCustomizeTermModal={props.showCustomizeTermModal}
      basicInfo={props.basicInfo}
      showResumeCaseModal={showResumeCaseModal}
      setShowResumeCaseModal={setShowResumeCaseModal}
      apiResponseData={apiResponseData} />
  </Fragment>;
}

Prudential.propTypes = {
  formData: PropTypes.object,
  quoter: PropTypes.object,
  basicInfo: PropTypes.object,
  logQuote: PropTypes.func,
  onBack: PropTypes.func,
  showCustomizeTermModal: PropTypes.bool,
};
